import Immutable from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
import AuthorsRecord from '../../records/manage/AuthorsRecord';
import AuthorRecord from '../../records/AuthorRecord';
const getAuthorInfo = payload => {
  const authorsRecord = new AuthorsRecord();
  return authorsRecord.set('authors', Immutable.OrderedMap(payload.map(({
    authorName,
    id
  }) => [id, new AuthorRecord({
    authorName,
    id
  })])));
};
export default function authorInfo(state = new AuthorsRecord(), action) {
  switch (action.type) {
    case ActionTypes.FETCH_AUTHORS_PENDING:
      return state.merge({
        isRequesting: true,
        error: undefined
      });
    case ActionTypes.FETCH_AUTHORS_SUCCESS:
      return getAuthorInfo(action.payload).merge({
        error: undefined,
        isRequesting: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.FETCH_AUTHORS_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error
      });
    default:
      return state;
  }
}